import styled from 'styled-components';

export const Bar = styled.div<{ $progress: number }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(
    90deg,
    rgba(50, 180, 160, 0),
    rgba(50, 220, 190, 0.8),
    rgba(50, 180, 160, 0)
  );
  transform: scaleX(${({ $progress }) => $progress});
  transform-origin: left;
  z-index: 1;
  pointer-events: none;
  transition: none;
`;
